import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useGetPlacesQuery } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { PlacesList } from "./components/PlacesList";
export var PlacesListPage = function () {
    var placeListGetState = useGetPlacesQuery({});
    var navigate = useNavigate();
    var onEditClickHandler = function (placeId) {
        navigate(RoutesList.Place.getPlaceEdit(placeId));
    };
    var onDetailsClickHandler = function (placeId) {
        navigate(RoutesList.Place.getPlaceDetails(placeId));
    };
    var onSchedulesClickHandler = function (placeId) {
        navigate(RoutesList.Place.getPlaceSchedules(placeId));
    };
    useSetPageData({ title: "Список площадок" });
    return (_jsxs("div", { children: [placeListGetState.isSuccess && (_jsx(PlacesList, { data: placeListGetState.data, onDetailsClick: onDetailsClickHandler, onEditClick: onEditClickHandler, onSchedulesClick: onSchedulesClickHandler })), _jsx(Loading, { isActive: placeListGetState.isFetching, loadingKey: "placeList" })] }));
};
